import { call, put, select } from 'redux-saga/effects';
import { setBillingDetails } from '../../../effects/organization';
import { setBannerAPIRequestState } from '../../../effects/message';
import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* updateBilling({ payload }) {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.ORGA}/${organizationId}/billing`;
  try {
    yield put(
      setBillingDetails({
        billingSuccess: false,
      }),
    );
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.PUT,
      body: payload.data,
    });
    if (!error && success) {
      if (payload.showBannerFeedback) {
        yield put(
          setBannerAPIRequestState({
            bannerState: 'success',
            bannerMessage: 'Billing information has been successfully updated!',
          }),
        );
      }
      yield put(
        setBillingDetails({
          result,
          billingSuccess: true,
        }),
      );
    } else if (payload.showBannerFeedback) {
      yield put(
        setBannerAPIRequestState({
          bannerState: 'error',
          bannerMessage:
            'Something went wrong while updating your billing information...',
        }),
      );
    }
  } catch (e) {
    console.error(e);
    if (payload.showBannerFeedback) {
      yield put(
        setBannerAPIRequestState({
          bannerState: 'error',
          bannerMessage:
            'Something went wrong while updating your billing information...',
        }),
      );
    }
  }
}
